/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
import { Layout, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import LabwareLogo from "../../shared/assets/images/labware_logo_new.svg";

const LoginBottomToolbar: React.FC<{}> = (props) => {
	const { t } = useTranslation();

	return (
		<Layout.Footer
			style={{
				position: "fixed",
				bottom: "0px",
				backgroundColor: "#FFF",
				width: "100%",
				padding: "5px 0",
				zIndex: 5,
				borderTop: "1px solid #73879c"
			}}
		>
			<Row justify="center">
				<img src={LabwareLogo} width="120px" height="40px" />
			</Row>
		</Layout.Footer>
	);
};

export default LoginBottomToolbar;
